// Library Imports
import { combineReducers } from 'redux';

// Local imports
import uiReducer from './uiReducer';
import errorReducer from './errorReducer';
import loadingReducer from './loadingReducer';
import { loginReducer } from 'modules/Login/reducer';
import previewArticleReducer from './previewArticleReducer';
import { userEntitiesReducer } from './userEntitiesReducer';
import { designReducer } from './../modules/Design/reducer';
import { publishReducer } from './../modules/Publish/reducer';
import { onBoardingReducer } from 'modules/OnBoarding/reducer';
import { preferenceReducer } from 'modules/Preference/reducers';
import { automationReducer } from 'modules/Automation/reducers';
import { analyticsFiltersReducer } from 'modules/Analytics/reducer';
import { emailBrowserReducer } from 'modules/EmailBrowser/reducers';
import { dragDropReducer } from 'modules/Content/DragnDrop/reducers';
import { editionDataReducer } from 'modules/Campaigns/Edition/reducer';
import { errorReducer as errorReducerNew } from 'modules/Error/reducer';
import { mostEngagedReducer } from 'modules/Content/MostEngaged/reducers';
import { searchArticlesReducer } from '../modules/Content/Search/reducers';
import { salesXGroupReducer } from './../modules/Settings/Manage/reducers';
import { analyticsContentReducer } from 'modules/Analytics/Content/reducer';
import { favoriteNewsReducer } from '../modules/Content/Favorites/reducers';
import { audienceListsReducerV2 } from 'modules/Audience/Reducers/listsReducer'; //New Audience Module Reducer
import { whnArticlesReducer } from '../modules/Content/WhatsHappeningNow/reducers';
import { formsAudienceReducer, formsReducer } from 'modules/Settings/Forms/reducers';
import { versionReducer, campaignDataForAssetReducer } from 'modules/Campaigns/reducers';
import { audienceListDetailsReducerV2 } from 'modules/Audience/Reducers/listDetailsReducer'; //New Audience Module Reducers
import { globalContactsReducerStore } from 'modules/Audience/Reducers/globalContactsReducer';
import { contactsFiltersReducerStore } from 'modules/Audience/Reducers/contactsFiltersReduer';
import { assetReducer, assetsReducer, emailsReducer } from 'modules/Campaigns/Emails/reducers';
import { accountsContentEngagementReducer } from 'modules/Analytics/Accounts/ContentEngagement/reducer';
import { accountsDashboardReducer, analyticsAccountsReducer } from 'modules/Analytics/Accounts/reducer';
import { analyticsDashboardReducer, analyticsGraphReducer } from 'modules/Analytics/Dashboard/reducers';
import { assetGraphReducer, assetsFiltersDataReducer } from 'modules/Campaigns/CampaignContent/reducers';
import { audienceListDetailsReducer, audienceListsReducer } from 'modules/Campaigns/Audience/Lists/reducer';
import { analyticsEmailTrendsReducer, analyticsClickTrendsReducer } from 'modules/Analytics/Insights/reducers';
import { myAccountsReducer, accountsNewsReducer, accountSearchReducer } from '../modules/Content/MyAccounts/reducers';
import { analyticsContactReducer, contactAuditTrailReducer, contactInnerDetailsReducer, emailEngagementReducer } from 'modules/Analytics/Contacts/reducer';
import { emailsWithoutCampaignsReducer, assetWithoutCampaignDetailsReducer } from 'modules/Campaigns/AssetsWithOutCampaigns/reducer';
import {
  campaignsReducer,
  campaignAssetGraphReducer,
  getCampaignNamesReducer,
  recommendedListsReducer,
  recommendedPeopleReducer,
  keywordsExplorerReducer,
  adHocTemplatesReducer,
  selectedRecommendedListsReducer,
  selectedRecommendedContactsReducer,
  aiEmailReducer,
} from 'modules/Campaigns/CampaignAssets/reducers';
import {
  audienceReducer,
  assetAudienceReducer,
  peopleAudienceReducer,
  searchRecommendedPeopleReducer,
  searchRecommendedListReducer,
  suggestedEmailsReducer,
  viewRecipientsReducer,
} from 'modules/Campaigns/Audience/reducer';
import { buyerJourneyReducer } from 'modules/BuyerJourney/reducer';

const appReducer = combineReducers({
  userEntities: userEntitiesReducer,
  myAccounts: myAccountsReducer,
  accountSearch: accountSearchReducer,
  accountsNews: accountsNewsReducer,
  user: loginReducer,
  whnArticles: whnArticlesReducer,
  searchArticles: searchArticlesReducer,
  isLoading: loadingReducer,
  error: errorReducer,
  campaignsGraphData: campaignAssetGraphReducer,
  assetGraphData: assetGraphReducer,
  versionGraphData: versionReducer,
  campaignDataForAsset: campaignDataForAssetReducer,
  emailBrowser: emailBrowserReducer,
  previewArticle: previewArticleReducer,
  assetDetails: assetReducer,
  assets: assetsReducer,
  design: designReducer,
  uiReducer: uiReducer,
  favoriteNews: favoriteNewsReducer,
  publish: publishReducer,
  mostEngaged: mostEngagedReducer,
  campaigns: campaignsReducer,
  dragDrop: dragDropReducer,
  emailsWithoutCampaigns: emailsWithoutCampaignsReducer,
  recommendedLists: recommendedListsReducer,
  recommendedPeople: recommendedPeopleReducer,
  selectedRecommendedList: selectedRecommendedListsReducer,
  selectedRecommendedContacts: selectedRecommendedContactsReducer,
  getCampaignNames: getCampaignNamesReducer,
  audience: audienceReducer,
  campaignAudience: assetAudienceReducer,
  peopleAudience: peopleAudienceReducer,
  assetsFiltersData: assetsFiltersDataReducer,
  keywordsExplorer: keywordsExplorerReducer,
  audienceLists: audienceListsReducer,
  audienceListDetails: audienceListDetailsReducer,
  searchRecommendedPeople: searchRecommendedPeopleReducer,
  searchRecommendedList: searchRecommendedListReducer,
  adHocTemplates: adHocTemplatesReducer,
  aiEmail: aiEmailReducer,
  assetWithoutCampaignDetails: assetWithoutCampaignDetailsReducer,
  editionData: editionDataReducer,
  analyticsDashboard: analyticsDashboardReducer,
  analyticsGraph: analyticsGraphReducer,
  suggestedEmails: suggestedEmailsReducer,
  viewRecipients: viewRecipientsReducer,
  onBoarding: onBoardingReducer,
  emails: emailsReducer,
  contactAnalytics: analyticsContactReducer,
  contactInnerDetails: contactInnerDetailsReducer,
  contactAuditTrail: contactAuditTrailReducer,
  analyticsAccounts: analyticsAccountsReducer,
  analyticsContent: analyticsContentReducer,
  accountsContentEngagement: accountsContentEngagementReducer,
  accountsDashboard: accountsDashboardReducer,
  analyticsFilters: analyticsFiltersReducer,
  automation: automationReducer,
  errors: errorReducerNew,
  emailTrends: analyticsEmailTrendsReducer,
  clickTrends: analyticsClickTrendsReducer,
  preferenceManagement: preferenceReducer,
  salesXGroups: salesXGroupReducer,
  // New Audience Module Reducers Imports
  audienceListsReducerV2,
  audienceListDetailsReducerV2,
  globalContacts: globalContactsReducerStore,
  contactsFilters: contactsFiltersReducerStore,
  forms: formsReducer,
  formsAudience: formsAudienceReducer,
  emailsEngagement: emailEngagementReducer,
  buyerJourney: buyerJourneyReducer,
});

const rootReducer = (state: any, action: any) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === 'USER_LOGGED_OUT') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
